export default {
  campagne: 'Nuestras campañas',
  published: 'Publicado el',
  archivio: 'Archivo de noticias',
  notizieCorrelate: 'Noticias relacionadas',
  modalitaDusoVino: 'Modo de empleo <br /> de las levaduras para <i>vino</i>',
  modalitaDusoBirra:
    'Modo de empleo <br /> de las levaduras para <i>cerveza</i>',
  buy: 'Comprar',
  richiediInfo: 'Solicitar información',
  etichettaAmbientale: 'Etiqueta ambiental',
  what: 'Qué es',
  where: 'Dónde va',
  raccoltaPlastica: 'Recogida de plástico',
  disposizioni: 'Verifica las disposiciones de tu municipio',
  disposizioniInfo:
    'Producto para uso profesional enológico conforme a: Reg. CEE/UE N°934/2019 e International Codex OIV',
  applicazioni: 'Aplicaciones',
  specificheTecniche: 'Especificaciones técnicas',
  preparazione: 'Preparación',
  scaricaScheda: 'Descargar ficha técnica',
  scaricaSchedaPanificati: 'Ficha técnica - Recetas',
  contenitore: 'Contenedor',
  tappo: 'Tapón',
  sottotappo: 'Sottotappo',
  tappoFlacone: 'Tapón de frasco',
  tappoTanica: 'Tapón de bidón',
  sacchetto: 'Bolsa',
  vediNews: 'Archivos de noticias',
  vediVideo: 'Todos los vídeos',
  news: 'Noticias',
  videos: 'Vídeos',
  leggi: 'Continuar leyendo',
  indietro: 'Volver',
  seeAll: 'Ver todo',
  filtri: 'Filtros',
  approfondisci: 'Descubre más',
  prodotto: 'Ir al producto',
  cancellaFiltri: 'Borrar filtros',
  modelTitle: 'Nuestros Atecnos: pioneros en la revolución de la levadura',
  modelText:
    'En 2012 fuimos los primeros en introducir en el mercado levaduras en crema. Atecnos se distingue gracias a una metodología exclusiva que reproduce fielmente los procesos naturales de multiplicación de las levaduras. Obtenemos una levadura fresca, de gran pureza, extremadamente reactiva y lista para su uso que permite la inoculación directa sobre el mosto.',
  iubendaCookiePolicyId: '68403814',
}
